"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../utils/constants");
var muiFastForwardFill16 = {
    paths: [
        {
            path: 'M7,0 C7.20021703,0 7.38669107,0.0588406961 7.54307309,0.160173039 L15.5153178,5.14282598 C15.8057509,5.31780464 16,5.63621767 16,6 C16,6.36378233 15.8057509,6.68219536 15.5153178,6.85717402 L7.54307309,11.839827 C7.38669108,11.9411593 7.20021703,12 7,12 C6.44771525,12 6,11.5522847 6,11 C6,10.6362177 6.19424909,10.3178046 6.48468221,10.142826 L13.1132038,6 L6.48468221,1.85717402 C6.19424909,1.68219536 6,1.36378233 6,1 C6,0.44771525 6.44771525,0 7,0 Z M0.268179976,0.250315219 C0.62320206,-0.0838820397 1.20087015,-0.0819395244 1.55046745,0.24715116 L1.55046745,0.24715116 L10,6 L1.55046745,11.7507149 C1.19730172,12.0831647 0.625677208,12.0840781 0.268179976,11.7475509 C0.0914752248,11.5812112 0.003232749,11.36295 0.00227475774,11.1450826 C0.001308024,10.9252269 0.00801704222,1.09340144 0.000521270278,0.885418292 C-0.00769591588,0.657418255 0.0812246437,0.426304158 0.268179976,0.250315219 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Fast Forward',
    width: 16,
    height: 12,
};
var muiFastForwardFill = {
    base: muiFastForwardFill16,
    smIcon: muiFastForwardFill16,
};
exports.muiFastForwardFill = muiFastForwardFill;
//# sourceMappingURL=fastForwardFill.js.map